export default function Footer() {
  return (
    <footer className="bg-[#0033A0] text-white text-center p-4">
      &copy; 2025 La Tapatía El Grullo. Todos los derechos reservados.
    </footer>
  );
}